export default "__VITE_ASSET__e2RokxAx__"